// @flow

export const prepareTime = (time) => new Date(time * 1000).toISOString().substr(11, 8)
